import React from 'react';
import { TaskStatus } from '../../../domain/types';
import { Task } from '../../../providers/api/dtos';
import useRBAC from '../../../hooks/use-rbac/useRBAC';

export interface UseComputedTaskStatusResult {
  status: TaskStatus,
  canBeUpdated: boolean,
  canBeUpdatedTo: (status: TaskStatus) => boolean,
}

const computedStatusCanBeUpdatedTo: Record<TaskStatus, TaskStatus[]> = {
  [TaskStatus.TODO]: [TaskStatus.IN_PROGRESS, TaskStatus.DONE],
  [TaskStatus.IN_PROGRESS]: [TaskStatus.TODO, TaskStatus.DONE],
  [TaskStatus.DONE]: [],
};

export const useComputedTaskStatus = ({ status, assignee }: Task): UseComputedTaskStatusResult => {
  const { userIsAdmin, userIsContentEditor, user } = useRBAC();

  const canBeUpdatedTo = React.useMemo(() => {
    if (userIsAdmin || userIsContentEditor || user.email === assignee) {
      return computedStatusCanBeUpdatedTo[status];
    }

    return [];
  }, [assignee, status, user.email, userIsAdmin, userIsContentEditor]);

  return React.useMemo(() => ({
    status,
    canBeUpdated: canBeUpdatedTo.length > 0,
    canBeUpdatedTo: (s: TaskStatus) => canBeUpdatedTo.includes(s),
  }), [canBeUpdatedTo, status]);
};
